import {i18n} from 'mc/lib';

export const N =  'N';
export const S =  'S';
export const P =  'P';
export const Z =  'Z';

const values = [N, S, P, Z];
const captions = {};

for (const value of values) {
    captions[value] = i18n('zadostRozhodnuti.' + value);
}

export function getCaption(value) {
    return captions[value] || '';
}
